import React, { useEffect, useRef, useState } from 'react';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import '../../modalright.css'
import '../../popup.css'
import axios from 'axios';
import jQuery from 'jquery';
import { useLocation } from 'react-router-dom';
import { CSVLink } from 'react-csv';
export default function Confirmation() {
    // Dummy data for drivers and locations
    const API_URL = process.env.REACT_APP_API_URL;
    const [activeTab, setActiveTab] = useState('ALL');
    const location = useLocation();
    const $ = jQuery.noConflict();
    const [orders, setOrders] = useState([]); // Store API response (orders)
    const [loading, setLoading] = useState(false); // For showing loading state
    const [error, setError] = useState(null); // For showing error messages
  
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [selectedRows, setSelectedRows] = useState([]);
console.log('selectedRows',selectedRows)
 const [drivers, setDrivers] = useState()

    const fetchDrivers = async () => {
      try {
          // Replace this API endpoint with the actual one that fetches drivers based on the emirate
          const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

          if (response.data.success) {
              const driversData = response.data.data;  // The array of driver objects

              // Map the response to extract driverId and name
              const driversList = driversData.map(driver => ({
                  driver_id: driver.driverId,
                  driver_name: driver.name
              }));

              // Set the drivers state
              setDrivers(driversList);
          } else {
              console.error('Error fetching drivers for emirate:');
          }
      } catch (error) {
          console.error('Error fetching drivers:', error);
      }
  };
    const getDriverName = (driverId) => {
      if (!Array.isArray(drivers)) {
        console.error('Drivers is not an array:', drivers);
        return 'Unknown';
      }
      const driver = drivers.find(driver => driver.driver_id === parseInt(driverId));
      return driver ? driver.driver_name : 'Unknown'; // Default to 'Unknown' if not found
  };


     useEffect(() => {
        
           
        
            $(".btn-demo.import").on('click',function(){
                    $('.nalier.middle-center.fade').css("display", "block");
                    $('.nalier.middle-center.fade').addClass("in");
            });
        
            $(".close.h-close").on('click',function(){
                    $('.nalier.middle-center.fade.in').css("display", "none");
                    $('.nalier.middle-center.fade').removeClass("in");

                    $('.nalier.middle-center2.fade.in').css("display", "none");
                    $('.nalier.middle-center2.fade').removeClass("in");

                    $('.nalier.middle-center3.fade.in').css("display", "none");
                    $('.nalier.middle-center3.fade').removeClass("in");
            });
      

            fetchDrivers();
            
        
        }, []);
    const columns = [
        // {
        //   name: 'AWB',
        //   selector: row => row.awb,  // Access 'awb' field directly
        //   sortable: true,
        // },
        {
          name: "AWB Number",
          selector: row => row.awb,
          sortable: true,
          cell: (row) => (
              <div style={{ width:'150px',wordWrap: 'break-word', whiteSpace: 'normal',textAlign:'left' }}>
                 <a className="alink" style={{cursor:'pointer',color:'#00a6ed'}} onClick={() => viewOrderDetails(row.awb)}>{row.awb} </a> 
              </div>
          ),
      },
        {
          name: 'Receiver Name',
          selector: row => row.consignee?.name || '', // Access nested 'consignee.name'
          sortable: true,
         
        
        },
        {
          name: 'Pickup Date',
          selector: row => row.consignee?.name || '', // Access nested 'consignee.name'
          sortable: true,
         
        
        },
        {
          name: 'Delivery Date',
          selector: row => row.consignee?.name || '', // Access nested 'consignee.name'
          sortable: true,
         
        
        },
        {
          name: 'Transmit time',
          selector: row => '2 days'|| '', // Access nested 'consignee.name'
          sortable: true,
         
        
        },
        {
          name: 'Status',
          selector: row => row.businessRefNo, // Access nested 'consignee.name'
          sortable: true,
          cell: (row) => (
            <div style={{ width:'150px',wordWrap: 'break-word', whiteSpace: 'normal',textAlign:'left' }}>
              {row.businessRefNo} 
            </div>
        ),
        
        },
        {
          name: 'Signature',
          selector: row => row.consignee?.phone || '',  // Access nested 'consignee.phone'
          sortable: true,
          
       
      
        },
        {
          name: 'Note',
          selector: row => row.consignee?.phone || '',  // Access nested 'consignee.phone'
          sortable: true,
          
       
      
        },
        
        
       
      ];
    const tableData = {
        columns,
        data: orders,
        export: true, // if you want export functionality, set it to true
        filterPlaceholder: 'Search...', // placeholder text for search input
      };


  const intervalRef = useRef(null);
  const activeTabRef = useRef(activeTab);

  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

      useEffect(() => {
       
        // Get today's date in YYYY-MM-DD format
        const today = new Date();
        const toDateFormatted = today.toISOString().split('T')[0]; // Today's date as YYYY-MM-DD
    
        // Get the date 7 days ago
        const fromDateFormatted = new Date(today);
        fromDateFormatted.setDate(today.getDate() - 7); // Subtract 7 days
        const fromDateStr = fromDateFormatted.toISOString().split('T')[0]; // 7 days ago in YYYY-MM-DD
    
        // Set the state with the default values (7 days ago to today)
        setFromDate(fromDateStr);
        setToDate(toDateFormatted);
        getOrdersChange(fromDateStr,toDateFormatted,activeTab)
      }, []);


      useEffect(() => {
        if (fromDate && toDate) {
          // Only set the interval if fromDate and toDate are valid
          if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
              getOrdersChange(fromDate, toDate,activeTabRef.current); // Call the function every minute
            }, 60000); // 60000ms = 1 minute
          }
    
          // Cleanup function to clear the interval when the component unmounts or dates become invalid
          return () => {
            if (intervalRef.current) {
              clearInterval(intervalRef.current); // Clear the interval
              intervalRef.current = null; // Reset the reference
            }
          };
        }
      }, [fromDate, toDate]); //
      
     
      const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
        getOrdersChange(e.target.value,toDate,activeTabRef.current)
      };
    
      const handleToDateChange = (e) => {
        setToDate(e.target.value);
        getOrdersChange(fromDate,e.target.value,activeTabRef.current)
      };

    const handleTabClick = async (tab) => {
        setActiveTab(tab); // Set active tab
        
        // Set loading state to true when making the API call
        setLoading(true);
        setError(null); // Reset any previous errors

        // Determine the status based on the selected tab
        let status = '';
        if (tab === 'ALL') {
            status = 'ALL';
        } 
        // API call to fetch orders based on the selected tab
        try {
          let response; 
          
             response = await axios.get(
              `${API_URL}shypvdriverapp/jobs/getOrdersByDateRangeAndStatus?fromDate=${fromDate}&toDate=${toDate}&status=${status}`
          );
          
          
            const ordersData = response.data.data.orders; // Extract orders from the response
            setOrders(ordersData); // Store the fetched data in state
        } catch (error) {
            // setError('Error fetching data. Please try again later.');
            setOrders([])
        } finally {
            setLoading(false); // Set loading to false after the API call is done
        }
    };
    
    const getOrdersChange = async (date1,date2,statusval) => {
      console.log('called')
        try {
          let response; 
          
          response = await axios.get(
            `${API_URL}shypvdriverapp/jobs/getOrdersByDateRangeAndStatus?fromDate=${date1}&toDate=${date2}&status=${statusval}`
        );
        const ordersData = response.data.data.orders; // Extract orders from the response
        setOrders(ordersData); // Store the fetched data in state
       
            
        } catch (error) {
            // setError('Error fetching data. Please try again later.');
            setOrders([])
        } finally {
            setLoading(false); // Set loading to false after the API call is done
        }

    }
    
    const handleEventClick = (event) => {
        const selectedDate = event.start.toISOString().split('T')[0];  // Get date in YYYY-MM-DD format
        const selectedEmirate = event.location;    // Access emirate directly from the event
        sessionStorage.setItem('selectedDate', selectedDate);  // Store selected date in sessionStorage
        sessionStorage.setItem('selectedEmirate', selectedEmirate);    // Store selected emirate in sessionStorage
        console.log(`Selected Date: ${selectedDate}, Emirate: ${selectedEmirate}`);
        window.location.href = '/orders/view'
    };

  // Check if all individual checkboxes are selected to update the "Select All" checkbox
  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const [selectedAWB, setSelectedAWB] = useState(null); // Track the selected AWB
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [images, setImages] = useState([]); // Images related to the AWB
  const [signatures, setSign] = useState([]); // Images related to the AWB

  const buttonsyle={
    background: '#00a6ed',
    color: '#fff',
    padding: '3px',
    marginRight: '10px',
    borderColor:'#00a6ed',
    cursor:'pointer',
    marginTop:'3%'
}
  const handleViewClick = async (awb,orderid,type) => {
    setSelectedAWB(awb);
    setImages([])
    setSign([])
    // Simulate fetching images related to this AWB (use your own logic here)
    const fetchedImages = await fetchImagesForAWB(orderid);
   
    // setImages(fetchedImages);
    $('.nalier.middle-center.fade').css("display", "block");
    $('.nalier.middle-center.fade').addClass("in");
  };

  const [msg, setMsg] = useState('')

 
  const handleViewReassign = async (awb,orderid) => {
    setMsg('')
    setSelectedAWB(awb);
    
   
    // setImages(fetchedImages);
    $('.nalier.middle-center2.fade').css("display", "block");
    $('.nalier.middle-center2.fade').addClass("in");
  };
 

  
      const [shipmentDetails, setShipmentDetails] = useState([]);

  const viewOrderDetails = async (awb) => {
    setMsg('')
    setSelectedAWB(awb);

    const payload = {

      awbNo: awb
  };

  console.log(payload)
  setError('processing....')
  axios.post(`${API_URL}shypvdriverapp/jobs/getJobDetails`, payload)
      .then(response => {
          console.log("Response:", response.data);
          setError('')
          if (response.data.success) {
              if(response.data.data.length >0 ){
                  setShipmentDetails(response.data.data)
              }else{
                  setShipmentDetails(response.data.data)
                  
                  setError('booking details not found')
              }
              
          } else {
              
              setShipmentDetails([])
              setError('booking details not found')
          }
      })
      .catch(error => {
          console.error("Error:", error);
      });
    
   
    // setImages(fetchedImages);
    $('.nalier.middle-center3.fade').css("display", "block");
    $('.nalier.middle-center3.fade').addClass("in");
  };

  console.log('shipmentDetails',shipmentDetails)
  // Function to simulate image fetching (replace with actual API call)
  const fetchImagesForAWB = async (orderid) => {
    // Replace with your own logic to fetch images (e.g., API call)
    const url = `${API_URL}shypvdriverapp/jobs/getJobById`;
    const params = {
        id: orderid // Job ID
    };

    // Make GET request using Axios
    axios.get(url, { params })
        .then(response => {
            // On success, store the response data in state
            console.log('fff,' ,response.data.data[0].preSignedUrlsByType)
            const attachmentUrls = Object.values(response.data.data[0].preSignedUrlsByType.Attachments);
            const signatureUrls = Object.values(response.data.data[0].preSignedUrlsByType.Signatures);
        
        setImages(attachmentUrls);
        setSign(signatureUrls);
            // setImages(response.data.data[0].preSignedUrlsByType.Attachments);
        })
        .catch(err => {
            // On error, store the error message in state
            setError('Error fetching job data: ' + err.message);
        });

  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAWB(null);
    setImages([]);
  };
const [assigndate, setAssigndate] = useState()



  const reAssign = async () => {
    if(assigndate && assigndate.trim() !== ''){
    try {
      const response = await axios.post(
        `${API_URL}shypvdriverapp/jobs/retryFailedOrders`,
        [
          {
            awb: selectedAWB,
            orderDate: assigndate,
          },
        ],
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if(response.data.success){
        setMsg('Orders is submitted for re assignment')
        $('.nalier.middle-center2.fade.in').css("display", "none");
        $('.nalier.middle-center2.fade').removeClass("in");
      }
      
      console.log('Response:', response.data);
    } catch (error) {
      console.
      error('Error:', error);
    }
  }else{
    setMsg('please select a date')
  }
  };


  const flattenOrderData = (orders) => {

    if (selectedRows && selectedRows.length > 0) {
      const selectedAWBs = selectedRows.map((row) => row.awb); // Get selected AWBs
      orders = orders.filter((order) => selectedAWBs.includes(order.awb)); // Filter orders by selected AWBs
    }
    return orders.map((order) => {
      // Flatten the data
      return {
        AWB: order.awb,
        'Client Ref':order.businessRefNo,
        'Customer Name': order.consignee?.name,  // Access nested 'consignee.name'
        Phone: order.consignee?.phone,            // Access nested 'consignee.phone'
        Address: order.consignee?.address,        // Access nested 'consignee.address'
        // ...(activeTab === 'DELIVERED'
        //   ? [
        //       {
        // 'COD Amount':order.codReceived,
        // Driver:getDriverName(order.driverId),
        //       }
        //     ]
        //     : []),
            'COD Amount':order.codReceived,
            Driver:getDriverName(order.driverId),
        Status: order.type,                       // Access 'type' field for order status
        Type: order.orderType,                       // Access 'type' field for order status
        'Assigned Date': order.date
      };
    });
  };

  const [filteredOrders, setFilteredOrders] = useState([]);

  
  const exportData = filteredOrders.length > 0 ? filteredOrders : orders;




    return (
        <div className="wrapper-holder">
        <div className="main-panel ps-container">
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header card-header-primary">
                                    
                                </div>
                                <div className="card-body">
   
<div id="datepicker" style={{float:'right'}}>
      <label htmlFor="fromDate">From Date: </label>
      <input 
        type="date" 
        id="fromDate" 
        value={fromDate} 
        onChange={handleFromDateChange} 
      />
      
      {/* To Date Picker */}
      <label htmlFor="toDate">To Date: </label>
      <input 
        type="date" 
        id="toDate" 
        value={toDate} 
        onChange={handleToDateChange} 
      />
       <CSVLink data={flattenOrderData(exportData)}    filename={`${activeTab}.csv`} style={{marginLeft:'10px'}}><i className='fa fa-download'></i></CSVLink>
   
</div>

                             
      {/* Main Tab Content */}
      <div className="tab-content">
        <h3 style={{float:'left'}}>Confirmation</h3>

        {activeTab === 'ALL'  && (
          <div>
              <div className="dispatchbtn" style={{ width: '24%' }}>
        
      </div>
      {loading && <p>Loading...</p>}

      <div style={{ overflowX: 'auto', width: '100%' }}>
  <DataTableExtensions {...tableData}>
    <DataTable
      columns={columns}
      data={orders}
      noHeader
      pagination
      highlightOnHover
      dense
      selectableRows
      onSelectedRowsChange={handleRowSelected}
      defaultSortField="awb"
      defaultSortAsc={true}
      searchable={orders.length > 0}
      customStyles={{
        header: {
          style: {
            minWidth: '100px', // Apply consistent minimum width
            textAlign: 'left',
          },
        },
        cells: {
          style: {
            minWidth: '100px',
            textAlign: 'left',
          },
        },
      }}
    />
  </DataTableExtensions>
</div>

{/* Display error message */}
{error && <p style={{ color: 'red' }}>{error}</p>}

{/* Display the fetched data in a table */}



            <div className="sub-tab-content">
             

            
            </div>
          </div>
        )}
      </div>
    </div>
                            </div>
                        </div>
                    </div>
                </div>

                

      <div className="nalier middle-center fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" style={{display: "none"}}>
                    <div className="nalier-dialog" style={{height:'auto'}} role="document">
                        <div className="nalier-content">

                        <div className="nalier-header">
                            <button type="button" className="close h-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="nalier-title" id="myModalLabel"> Details - {selectedAWB}</h4>
                        </div>
                        <div className="nalier-body">
                        <div className="modal-gap">&nbsp;</div>


                        <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }} >
                        {/* <h2>AWB Details: {selectedAWB}</h2> */}
        <div>
          <h4>Images:</h4>
          {images.length > 0 ? (
            <div>
              {images.map((image, index) => (
                <img key={index} src={image} alt={`AWB-${selectedAWB}-${index}`} style={{ width: '100%', margin: '10px' }} />
              ))}
            </div>
          ) : (
            <p>No images available</p>
          )}
  <h4>Signature:</h4>
{signatures.length > 0 ? (
            <div>
              {signatures.map((image, index) => (
                <img key={index} src={image} alt={`AWB-${selectedAWB}-${index}`} style={{ width: '100px', margin: '10px' }} />
              ))}
            </div>
          ) : (
            <p>No images available</p>
          )}
        </div>   
                              </div>
                              <div className="row">
                                  <div className="col-md-6"></div>
                                  <div className="col-md-5">
                          
                                </div>
                                </div>
                              </div>

                        </div>
                        </div>
                        </div>


                        {/* reassignment */}

                        <div className="nalier middle-center2 fade" id="myModal2" role="dialog" aria-labelledby="myModalLabel" style={{display: "none"}}>
                    <div className="nalier-dialog" style={{height:'auto'}} role="document">
                        <div className="nalier-content">

                        <div className="nalier-header">
                            <button type="button" className="close h-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="nalier-title" id="myModalLabel">Re assign - {selectedAWB}</h4>
                        </div>
                        <div className="nalier-body">
                        <div className="modal-gap">&nbsp;</div>


                        <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }} >
                        {/* <h2>AWB Details: {selectedAWB}</h2> */}
       <div className="form-group">
          <label>Date for Assignment: </label>
         <input type="date" onChange={(e)=>setAssigndate(e.target.value)}/>

        </div>  
        <a onClick={reAssign} style={buttonsyle} type="button" className="btn-demo add">
                                            Submit
                                        </a> 
                                        <p>{msg}</p>
                              </div>
                              <div className="row">
                                  <div className="col-md-6"></div>
                                  <div className="col-md-5">
                          
                                </div>
                                </div>
                              </div>

                        </div>
                        </div>
                        </div>


                         {/* reassignment */}

                         <div className="nalier middle-center3 fade" id="myModal3" role="dialog" aria-labelledby="myModalLabel" style={{display: "none"}}>
                    <div className="nalier-dialog" style={{height:'auto'}} role="document">
                        <div className="nalier-content">

                        <div className="nalier-header">
                            <button type="button" className="close h-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="nalier-title" id="myModalLabel">Order Details- {selectedAWB}</h4>
                        </div>
                        <div className="nalier-body">
                        <div className="modal-gap">&nbsp;</div>


                        <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }} >
                        {/* <h2>AWB Details: {selectedAWB}</h2> */}
       <div className="form-group">
        <p>{error}</p>
       {shipmentDetails && shipmentDetails.map((data, index) => (
  <div key={index} className="tracking-item">
    <div className="tracking-header">
      {/* <h3>Shipment {data.order_id}</h3> */}
      <span>..............................................................</span>
    </div>
    <div className="tracking-body">
      <div className="tracking-info">
        <strong>Status:{data.status}</strong> 
       
      </div>
      <div className="tracking-info">
        <strong>Date:</strong> {data.date}
      </div>
      <div className="tracking-info">
        <strong>Driver ID:</strong> {getDriverName(data.driverId)}
      </div>
      <div className="tracking-info">
        <strong>Updated By:</strong> {data.updatedBy}
      </div>
    </div>
    <div className="tracking-footer">
      
    </div>
  </div>
))}

        </div>   
                                        <p>{msg}</p>
                              </div>
                              <div className="row">
                                  <div className="col-md-6"></div>
                                  <div className="col-md-5">
                          
                                </div>
                                </div>
                              </div>

                        </div>
                        </div>
                        </div>
            </div>
        </div>
    </div>
    );
}
